import React, { useEffect, useState } from "react";
import { color_grey_light, color_white } from "../../constants/colors";
import { useWindowDimensions } from "../../utils";
import { Link, OnestNormalSmall } from "../styled/TextComponents";
import { ButtonDefault } from "../controls/Button/ButtonDefault";
import { useI18n } from "../../i18n/I18nProvider";

const ModalCookies = () => {
    const { t } = useI18n();
    const { width: screenWidth } = useWindowDimensions();
    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
        const handleCookies = () => {
            // Logic to check if cookies are accepted
            const cookiesAccepted = localStorage.getItem("cookiesAccepted");
            if (!cookiesAccepted) {
                setIsOpen(true);
            }
        };

        handleCookies();
    }, []);

    if (isOpen) {

        return (
            <div style={{
                position: "fixed",
                bottom: 20,
                right: 20,
                display: "flex",
                width: screenWidth > 530 ? 452 : 190,
                height: screenWidth > 530 ? 40 : 'min-content',
                padding: 20,
                borderRadius: 20,
                flexDirection: screenWidth > 530 ? "row" : "column",
                alignItems: "center",
                justifyContent: screenWidth > 530 ? "space-between" : "center",
                backgroundColor: color_white,
                gap: screenWidth > 530 ? 24 : 12,
                boxShadow: "4px 4px 16px rgba(0,0,0,0.15)",
            }}>
                <OnestNormalSmall style={{flex: 1}} >
                    {t("Пользуясь нашим сайтом, вы соглашаетесь с тем, что мы используем")}{" "}
                    <Link as="a" href="/privacy-policy.html" target="_blank">cookies</Link>
                </OnestNormalSmall>
                <ButtonDefault
                    
                    width={screenWidth > 530 ? 131 : "100%"}
                    height={40}
                    borderRadius={20}
                    padding={10}
                    onClick={() => {
                        localStorage.setItem("cookiesAccepted", "true");
                        setIsOpen(false);
                    }}>
                    {t("Хорошо")}
                </ButtonDefault>
            </div>
        )
    }
    else {
        return null;
    }
}

export default ModalCookies